var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7326 3.56622C22.0903 3.20793 22.0903 2.62702 21.7326 2.26872C21.3749 1.91043 20.795 1.91043 20.4372 2.26872L12.0004 10.7194L3.56366 2.26875C3.20595 1.91045 2.62599 1.91045 2.26828 2.26875C1.91057 2.62704 1.91057 3.20795 2.26828 3.56625L10.7051 12.0169L2.30198 20.4337C1.94428 20.792 1.94428 21.373 2.30198 21.7312C2.65969 22.0895 3.23965 22.0895 3.59736 21.7313L12.0004 13.3144L20.4035 21.7313C20.7612 22.0896 21.3412 22.0896 21.6989 21.7313C22.0566 21.373 22.0566 20.7921 21.6989 20.4338L13.2958 12.0169L21.7326 3.56622Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.df1020a4b92c7ee4f06ebf8d06297e20.svg";
export { ForwardRef as ReactComponent };